module.exports = __webpack_public_path__ + "img/default-theme.ace0cfc2.jpg";